import React, { Component } from "react";

class PersonalInfo extends Component {
  render() {
    return (
      <React.Fragment>
        <h2 className="mb-4">Profile Information</h2>

        <form id="profileForm" className="gorilla-form">
          <div className="row g-3">

            {/* First Name */}
            <div className="col-12 col-md-6">
              <label className="form-label">First Name</label>
              <input
                name="first_name"
                value={this.props.user?.first_name || ""}
                className="form-control readonly"
                  style={{background: "white", outline: "3px solid #F5F5F5"}}
                readOnly
                placeholder="First Name"
              />
            </div>

            {/* Last Name */}
            <div className="col-12 col-md-6">
              <label className="form-label">Last Name</label>
              <input
                name="last_name"
                value={this.props.user?.last_name || ""}
                className="form-control readonly"
                                  style={{background: "white", outline: "3px solid #F5F5F5"}}

                readOnly
                placeholder="Last Name"
              />
            </div>

            {/* City */}
            <div className="col-12 col-md-6 mt-2">
              <label className="form-label">City</label>
              <input
                name="city"
                value={this.props.user?.city || ""}
                className="form-control readonly"
                style={{background: "white", outline: "3px solid #F5F5F5"}}
                readOnly
                placeholder="City"
              />
            </div>

            {/* Zip */}
            <div className="col-12 col-md-6 mt-2">
              <label className="form-label">Zip Code</label>
              <input
                name="zipcode"
                value={this.props.user?.zip || ""}
                className="form-control readonly"
                style={{background: "white", outline: "3px solid #F5F5F5"}}
                readOnly
                placeholder="Zip"
              />
            </div>

            {/* Email */}
            <div className="col-12 col-md-6 mt-2">
              <label className="form-label">Email</label>
              <input
                name="email"
                value={this.props.user?.email || ""}
                className="form-control readonly"
                style={{background: "white", outline: "3px solid #F5F5F5"}}
                readOnly
                placeholder="Email"
              />
            </div>

            {/* IMDb */}
            <div className="col-12 col-md-6 mt-2">
              <label className="form-label">IMDb Link</label>
              <input
                name="imdb_link"
                value={this.props.user?.imdb || ""}
                className="form-control readonly "
                  style={{background: "white", outline: "3px solid #F5F5F5"}}
                readOnly
                placeholder="IMDb Link"
              />
            </div>

            {/* About */}
            <div className="col-12 mt-2">
              <label className="form-label">About Me</label>
              <textarea
                name="aboutme"
                value={this.props.user?.tell_us || ""}
                className="form-control readonly"
                style={{ minHeight: "140px", background: "white", outline: "3px solid #F5F5F5" }}
                readOnly
                placeholder="Tell us about yourself"
              />
            </div>

          </div>
        </form>
      </React.Fragment>
    );
  }
}

export default PersonalInfo;